import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';
import { getMutationFn } from '../../../common/queryClient/getMutationFn';

import { LatestCommentsType, UserReadCommentType } from '../schema/types';
import { UserCalendarUrl } from '../../UserDashboardUrl';

const postUserReadComment = (userReadComments: UserReadCommentType[]) =>
  apiClient
    .post<LatestCommentsType>(
      expand(UserCalendarUrl.USER_READ_COMMENT),
      userReadComments,
    )
    .then((response) => response.data);

export const useMutateUserReadCommentQuery = createApiMutationHook(
  ['user-read-comment'],
  getMutationFn(postUserReadComment, undefined, undefined),
);
